import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Grid, Menu, MenuItem, ListItemIcon, Drawer, List, ListItem, ListItemText, Switch } from '@mui/material';
import { Home as HomeIcon, Flight as FlightIcon, Info as InfoIcon, Menu as MenuIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

interface NavbarProps {
  onThemeChange: () => void;
  darkMode: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ onThemeChange, darkMode }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem component={Link} to="/" onClick={handleMenuClose}>
        <HomeIcon sx={{ mr: 1 }} /> Home
      </MenuItem>
      <MenuItem component={Link} to="/simulados" onClick={handleMenuClose}>
        <FlightIcon sx={{ mr: 1 }} /> Simulados
      </MenuItem>
      <MenuItem component={Link} to="/informacoes" onClick={handleMenuClose}>
        <InfoIcon sx={{ mr: 1 }} /> Informações
      </MenuItem>
    </Menu>
  );

  const renderDrawer = (
    <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
      <Box sx={{ width: 250 }} onClick={handleDrawerToggle} onKeyDown={handleDrawerToggle}>
        <List>
          <ListItem button component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component={Link} to="/simulados">
            <ListItemIcon>
              <FlightIcon />
            </ListItemIcon>
            <ListItemText primary="Simulados" />
          </ListItem>
          <ListItem button component={Link} to="/informacoes">
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="Informações" />
          </ListItem>
        </List>
        <Switch checked={darkMode} onChange={onThemeChange} />
      </Box>
    </Drawer>
  );

  return (
    <AppBar position="fixed" sx={{ bgcolor: theme.palette.background.default, boxShadow: 'none', borderBottom: `1px solid ${theme.palette.divider}` }}>
      <Toolbar>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>
              Banca Simulados ANAC
            </Typography>
          </Grid>
          <Grid item sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton onClick={handleDrawerToggle}>
              <MenuIcon sx={{ color: theme.palette.text.primary }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton component={Link} to="/">
                <HomeIcon sx={{ color: theme.palette.text.primary }} />
              </IconButton>
              <IconButton component={Link} to="/simulados">
                <FlightIcon sx={{ color: theme.palette.text.primary }} />
              </IconButton>
              <IconButton component={Link} to="/informacoes">
                <InfoIcon sx={{ color: theme.palette.text.primary }} />
              </IconButton>
              <Switch checked={darkMode} onChange={onThemeChange} />
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
      {renderMenu}
      {renderDrawer}
    </AppBar>
  );
};

export default Navbar;
